<template>
    <div class="datepicker form-group">
        <v-date-picker
            v-model="rangeDates"
            is-range
            timezone="UTC"
        >
            <template v-slot="{ inputValue, inputEvents }">
                <div class="input-group">
                    <div
                        class="
                            d-flex
                            flex-column
                            flex-md-row
                            align-items-lg-end
                            gap-2
                        "
                    >
                        <div class="d-flex flex-column">
                            <label
                                v-if="labels[0]"
                                class="form-group-label mb-1"
                            >
                                {{ labels[0] }}
                            </label>
                            <div class="position-relative">
                                <input
                                    :value="inputValue.start"
                                    v-on="inputEvents.start"
                                    class="form-control"
                                >
                                <ui-icon
                                    icon="calendar"
                                    class="datepicker-icon"
                                />
                            </div>
                        </div>

                        <span class="hidden d-md-block seperator">
                            -
                        </span>

                        <div class="d-flex flex-column">
                            <label
                                v-if="labels[1]"
                                class="form-group-label mb-1"
                            >
                                {{ labels[1] }}
                            </label>
                            <div class="position-relative">
                                <input
                                    :value="inputValue.end"
                                    v-on="inputEvents.end"
                                    class="form-control"
                                >
                                <ui-icon
                                    icon="calendar"
                                    class="datepicker-icon"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </v-date-picker>
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    import UiIcon from './icon.vue';

    export default {
        name: 'UiDatePickerRange',
        components: {
            UiIcon,
        },
        props: {
            labels: {
                type: Array,
                default: () => [],
            },
            range: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                rangeDates: {},
            };
        },
        async mounted() {
            await this.$nextTick();

            if (this.range.start !== '') {
                this.rangeDates = {
                    start: dayjs(this.range.start).format(),
                    end: dayjs(this.range.end).format(),
                };
            }
        },
        watch: {
            rangeDates() {
                if (!this.rangeDates.start) return;

                // TODO: remove emit from watch
                this.$emit('input', {
                    start: dayjs(this.rangeDates.start).toISOString(),
                    end: dayjs(this.rangeDates.end).toISOString(),
                });
            },

            'range.start'() {
                this.rangeDates = {};
            },
        },
    };
</script>

<style lang="scss">
    .datepicker {
        &-icon {
            position: absolute;
            top: 50%;
            right: 0;
            width: 50px;
            font-size: rem(24px);
            color: $gray;
            pointer-events: none;
            transform: translateY(-50%);
        }

        .form-control {
            min-width: 140px;
            padding-right: 50px;
        }
    }
</style>

<style lang="scss" scoped>
    .input-group {
        flex-wrap: nowrap;
    }

    .seperator {
        line-height: 48px;
    }
</style>
